export default __webpack_public_path__ + "static/media/logo.abf5498d.svg";